import AppButton from "@/components/AppButton.vue";
import ImageProfile from "@/components/ImageProfile.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ImageProfile,
    ModalCodigo,
    HeaderColor,
    AppButton,
  },
})
export default class PerfilDelivery extends Vue {
  userData: any = JSON.parse(sessionStorage.getItem("USER_DATA") || "{}");
  // Delivery variables
  cepDelivery = "";
  provincyDelivery = "";
  cityDelivery = "";
  neighDelivery = "";
  streetDelivery = "";
  numberDelivery = "";
  complementDelivery = "";
  //User definitions
  firstName: string = this.userData.FIRST_NAME || "";
  lastName: string = this.userData.LAST_NAME || "";
  fullName: string = this.firstName + " " + this.lastName;
  cpf: string = this.userData.CPF;
  npf: string = JSON.parse(sessionStorage.getItem("NPF") || "0");
  phoneNumber: string =
    this.userData.CONTACTS && this.userData.CONTACTS[0]
      ? this.userData.CONTACTS[0].PHONE
      : "";
  email: string = this.userData.EMAIL;
  imgProfile: string = this.userData.IMAGE;

  preferences: any = JSON.parse(sessionStorage.getItem("PREFERENCES") || "[]");
  selectedCategories: any = JSON.parse(
    sessionStorage.getItem("SELECTED_CATEGORIES") || "[]"
  );
  selectedTags: any = JSON.parse(
    sessionStorage.getItem("SELECTED_TAGS") || "[]"
  );

  showModal = false;
  modalIcon = "error_outline";
  modalMessage =
    "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde.";

  showModalDelete = false;
  modalMessageDelete =
    "Esta é uma operação irreversível! Confirma a exclusão do seu perfil?";

  showModalMsg = false;
  modalMsg = "";

  notificacao: any = sessionStorage.getItem("HAS_NOTIFICATION");
  orgPreferences: boolean = JSON.parse(
    sessionStorage.getItem("ORG_PREFERENCES") || "false"
  );
  noDeliveryAddress = false;
  backButton: any = {
    iconClass: "fas",
    icon: "chevron-left",
    show: true,
    callback: this.goBack,
  };

  hasLoyaltyProgram: boolean = JSON.parse(
    sessionStorage.getItem("FIDELITY_PROGRAM") || "false"
  );
  loyaltyProgramInfo: any = JSON.parse(
    sessionStorage.getItem("FIDELITY_PROGRAM_INFO") || "{}"
  );
  loyaltyPoints: number = Number(this.loyaltyProgramInfo.userScore) || 0;
  necessaryScore = Number(this.loyaltyProgramInfo.necessaryScore);
  percentagePoints = 0;

  filledUserData = true;
  cameFromConfirmCode = JSON.parse(
    sessionStorage.getItem("CAME_FROM_CONFIRM_CODE") || "false"
  );

  created() {
    if (this.hasLoyaltyProgram) {
      this.calcLoyalty();
    }
  }

  mounted() {
    Util.setBackButtonBehavior(this.goBack);

    if (this.npf) {
      this.addMaskNpf();
    }

    if (this.cpf) this.cpf = Util.addCpfMask(this.cpf);
    this.updateDeliveryInputs();

    if (sessionStorage.getItem("USER_DATA")) this.fillUserData();
    else
      this.getUserData((response: any) => {
        this.fillUserData(response.user);
      });
  }

  addMaskNpf() {
    const npfStr = new String(this.npf);
    const len: number = npfStr.length;
    if (len > 3) {
      this.npf =
        npfStr[0] + " " + npfStr.substring(1, len - 1) + "-" + npfStr[len - 1];
    }
  }

  updateDeliveryInputs() {
    const deliveryAddress = this.userData.ADDRESS.find(
      (address: any) => address.TYPE == "DELIVERY"
    );
    if (deliveryAddress) {
      this.cepDelivery = deliveryAddress.CEP;
      this.numberDelivery = deliveryAddress.NUMBER;
      this.streetDelivery = deliveryAddress.STREET;
      this.neighDelivery = deliveryAddress.NEIGHBORHOOD;
      this.provincyDelivery = deliveryAddress.PROVINCY;
      this.cityDelivery = deliveryAddress.CITY;
      this.complementDelivery = deliveryAddress.COMPLEMENT;
    } else this.noDeliveryAddress = true;
  }

  fillUserData(user: any = null) {
    user = user ? user : this.userData;
    this.filledUserData = false;

    const self = this;
    if (user) {
      this.userData = user;
      sessionStorage.setItem("USER_DATA", JSON.stringify(user));
      self.firstName = user.FIRST_NAME;
      self.lastName = user.LAST_NAME;
      self.fullName = this.firstName + " " + this.lastName;
      self.cpf = user.CPF ? Util.addCpfMask(user.CPF) : "";
      self.email = user.EMAIL ? user.EMAIL : user.ORGANIZATION_DATA.EMAIL;
      self.imgProfile = user.IMAGE;

      if (user.CONTACTS && user.CONTACTS[0]) {
        self.phoneNumber = user.CONTACTS[0].PHONE;
      }
      sessionStorage.setItem("USER_DATE", JSON.stringify(user));
      setTimeout(function () {}, 50);
    }
    setTimeout(() => {
      this.filledUserData = true;
    }, 200);
  }

  mostraModal(message: string, icon: string) {
    this.modalMessage = message;
    this.modalIcon = icon;
    this.showModal = true;
  }

  fechaModal() {
    this.getUserData(() => {});
    this.showModal = false;
  }

  getUserData(callback: any) {
    try {
      const req = new Request();
      req.body = {
        USER_ID: sessionStorage.getItem("USER_ID") || "",
        USER_TYPE_ID: 1,
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN") || "",
        TOKEN_EXT: sessionStorage.getItem("TOKEN_EXT") || "",
      };
      req.route = "getUserData";
      req.callbackSuccess = callback;
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  goToContactEdit() {
    this.$router.push("ContactEdit");
  }

  goToAddressEdit() {
    sessionStorage.setItem("ENTERED_ADD_ADDRESS_FROM", "PerfilDelivery");
    this.$router.push("AddAddress");
  }

  goToPreferences() {
    this.$router.push("Personalize");
  }

  goBack() {
    if (this.cameFromConfirmCode) {
      sessionStorage.setItem("CAME_FROM_CONFIRM_CODE", "false");
      this.$router.go(-2);
    } else {
      this.$router.go(-1);
    }
  }

  calcLoyalty() {
    if (!this.loyaltyProgramInfo) return 0;

    if (this.loyaltyProgramInfo.type === "value") {
      const score = this.loyaltyPoints;
      const necessary = parseFloat(this.loyaltyProgramInfo.necessaryScore || 1);
      return Math.min(100, (100 * score) / necessary);
    }

    if (this.loyaltyProgramInfo.type === "quantity") {
      const purchases = parseInt(
        this.loyaltyProgramInfo.purchasesMadeByTheUser || 0
      );
      const necessary = parseInt(
        this.loyaltyProgramInfo.mandatoryPurchasesNecessary || 1
      );
      return Math.min(100, (100 * purchases) / necessary);
    }

    return 0;
  }

  deleteUserModal() {
    this.showModalDelete = true;
  }

  deleteUser() {
    const self = this;
    self.showModalDelete = false;
    try {
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
      };
      req.route = "deleteUser";
      req.callbackSuccess = function () {
        self.openModalMsg("Perfil excluido com sucesso.");
      };
      req.callbackError = function (error: any) {
        self.openModalMsg("Ocorreu um erro, favor tente mais tarde.");
        console.log(error);
      };
      req.send();
    } catch (e) {
      console.log(e);
      self.openModalMsg("Ocorreu um erro, favor tente mais tarde.");
    }
  }

  openModalMsg(modalMsg: string) {
    this.showModalMsg = true;
    this.modalMsg = modalMsg;
  }

  closeModalMsg() {
    this.showModalMsg = false;
    sessionStorage.setItem("USER_ID", "");
    sessionStorage.setItem("USER_DATA", "");
    sessionStorage.setItem("TOKEN", "");
    const homeRoute = Util.verifyRouteHome();
    this.$router.push(homeRoute);
  }
}
